import { EmptyView } from "@eusoft/webapp-framework/components/EmptyView";
import { MessageBoxButton, userInteraction } from "@eusoft/webapp-framework/services/UserInteraction";
import { forModel } from "@eusoft/webapp-jsx/Helpers";
import { contentInfo } from "@eusoft/webapp-ui/abstraction/IContent";
import { formatText } from "@eusoft/webapp-ui/utils/Format";
import { navigatePage } from "../../actions/Common";
import { userSession } from "../../services/UserSession";
import type { Guid } from "../../entities/Commands";
import { Content } from "@eusoft/webapp-ui/components/Content";
import { registerComponent } from "@eusoft/webapp-core";


export interface IAcceptAccessRequestArgs {
    reqId: Guid;
}

export class AcceptAccessRequestPage extends Content<IAcceptAccessRequestArgs> {
    constructor() {
        super();
        this.init(AcceptAccessRequestPage, {
            title: "accept-access-request",
            style: ["panel"],
            body: forModel(this, m => <>

                <EmptyView
                    iconName="lock_clock"
                    message="msg-access-verify"
                />

            </>)
        });
    }

    protected override async onLoadAsync(args: IAcceptAccessRequestArgs) {

        console.log(args.reqId);

        this.reqId = args.reqId;    
        return true;
    }

    override async onOpenAsync() {

        try {
            const res = await userSession.openAsync({
                accessRequestId: this.reqId,

            }, true);

            if (!res?.accessToken)
                throw new Error("err-unknown");
        }
        catch (err) {
            await userInteraction.messageBoxAsync(formatText(err.message), "error", MessageBoxButton.Ok);
        }

        navigatePage("home", null, "replace");
    }

    reqId: Guid = undefined;  
    
    hideContext = true;

    hideBottomNav = true;

    static override info = contentInfo({
        route: "/access-request/{reqId}",
        name: "access-request",
        factory: () => new AcceptAccessRequestPage()
    })
}

registerComponent(AcceptAccessRequestPage, "AcceptAccessRequestPage");